import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from "react";

/**
 * Get the current canonical or document URL
 * @returns {string}
 */
export var getDocumentUrl = function getDocumentUrl() {
  var canonical = document.querySelector("link[rel=canonical]");
  return canonical && canonical.href || document.location.href;
};

/**
 * Convert the given absolute to a relative URL
 * @param {string} url
 * @returns {string}
 */
export var toRelative = function toRelative(url) {
  return url.replace(/^[^/]+\/\/[^/]+/, "");
};
export var toAbsolute = function toAbsolute(url) {
  return url.match(/^[^/]+:\/\//) ? url : "https://www.mibaby.de" + url;
};

/**
 * Sets query string parameters no the given URL
 * @param {string} url
 * @param {object} query
 * @returns {string}
 */
export var setQuery = function setQuery(url, query) {
  url = new URL(url);
  for (var k in query) {
    url.searchParams.set(k, query[k]);
  }
  return url.toString();
};

/**
 * Use the current document URL.
 * @param {boolean} rel Relative or absolute
 * @param {object} query Overwrite query params
 * @returns {string}
 */
export default function useUrl() {
  var rel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var query = arguments.length > 1 ? arguments[1] : undefined;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    url = _useState2[0],
    setUrl = _useState2[1];
  useEffect(function () {
    var href = getDocumentUrl();
    query && (href = setQuery(href, query));
    rel && (href = toRelative(href));
    setUrl(href);
  }, [rel, query]);
  return url;
}
//# sourceMappingURL=useUrl.js.map